module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/plans-detail-dialog1-90d4d174c67eb3818f622f7354a80f7b.jpg";